import Swal from "sweetalert2"

function applyEyesolSwalStyles(popup) {
  popup.style.fontSize = "13px"

  const titleEl = popup.querySelector(".swal2-title")
  if (titleEl) {
    titleEl.style.fontSize = "1.1rem"
    titleEl.style.padding = "0.4rem 0.6rem 0.2rem"
    titleEl.style.fontWeight = "600"
  }

  const htmlContainer = popup.querySelector(".swal2-html-container")
  if (htmlContainer) {
    htmlContainer.style.maxHeight = "none"
    htmlContainer.style.overflow = "visible"
    htmlContainer.style.fontSize = "0.82rem"
    htmlContainer.style.lineHeight = "1.35"
    htmlContainer.style.margin = "0.5rem 0.8rem"
    htmlContainer.style.textAlign = "center"
  }

  const actions = popup.querySelector(".swal2-actions")
  if (actions) {
    actions.style.marginTop = "0.7rem"
  }

  const confirmBtn = popup.querySelector(".swal2-confirm")
  if (confirmBtn) {
    confirmBtn.style.fontSize = "0.82rem"
  }
}

function formatMessage(message) {
  return String(message || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .join("<br>")
}

function baseAlertOptions() {
  return {
    showConfirmButton: true,
    confirmButtonText: "OK",
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: true,
    didOpen: applyEyesolSwalStyles
  }
}

export default class PrescreenNotificationModule {
  success(message = "Updated!") {
    return Swal.fire({
      ...baseAlertOptions(),
      icon: "success",
      title: message
    })
  }

  error(message = "An error occurred.") {
    const multiline = String(message).includes("\n")

    return Swal.fire({
      ...baseAlertOptions(),
      icon: "warning",
      title: multiline ? "Please review" : message,
      html: multiline ? formatMessage(message) : undefined
    })
  }

  confirmDelete({
    title = "Are you sure?",
    message = "",
    confirmButtonText = "Yes, delete",
    cancelButtonText = "Cancel"
  } = {}) {
    return Swal.fire({
      icon: "warning",
      title: title,
      html: message ? formatMessage(message) : undefined,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: true,
      didOpen: applyEyesolSwalStyles
    })
  }
}
